/** Inline stroke icons from the design system: 1.6 to 2px, round caps, currentColor. */
const paths = {
  table: "M2.5 3.5h11v9h-11zM2.5 6.5h11M2.5 9.5h11M6.5 3.5v9",
  list: "M6 4.5h7.5M6 8h7.5M6 11.5h7.5M2.6 4.5h.1M2.6 8h.1M2.6 11.5h.1",
  coins: "M8 2.5a5.5 5.5 0 100 11 5.5 5.5 0 100-11M8 4.8v6.4M9.8 6.3c-.4-.5-1-.7-1.8-.7-1 0-1.7.5-1.7 1.2 0 1.7 3.6.8 3.6 2.5 0 .8-.8 1.3-1.9 1.3-.8 0-1.5-.3-1.9-.9",
  swords: "M2.5 2.5l8 8M2.5 2.5v2.5M2.5 2.5H5M13.5 2.5l-8 8M13.5 2.5v2.5M13.5 2.5H11M9 12l2.5-2.5M7 12L4.5 9.5M11.5 11.5l2 2M4.5 11.5l-2 2",
  grenade: "M8 5.5a4 4 0 100 8 4 4 0 100-8M7 5.6V3.5h2.5M9.5 3.5l1.8-1.3M6.5 8.5h3",
  heat: "M8 2.2c2.2 2.6 3.8 4.4 3.8 6.8a3.8 3.8 0 01-7.6 0c0-1.6.8-2.7 1.7-3.6.2 1.2.8 2 1.7 2.4C7.4 6.1 7.4 4.2 8 2.2z",
  gear: "M6.9 1.6h2.2l.4 1.7 1.3.6 1.5-.9 1.6 1.6-.9 1.5.6 1.3 1.7.4v2.2l-1.7.4-.6 1.3.9 1.5-1.6 1.6-1.5-.9-1.3.6-.4 1.7H6.9l-.4-1.7-1.3-.6-1.5.9-1.6-1.6.9-1.5-.6-1.3-1.7-.4V6.9l1.7-.4.6-1.3-.9-1.5 1.6-1.6 1.5.9 1.3-.6zM8 6a2 2 0 100 4 2 2 0 100-4",
  help: "M8 2.5a5.5 5.5 0 100 11 5.5 5.5 0 100-11M6.3 6.4a1.8 1.8 0 113 1.3c-.7.4-1.3.9-1.3 1.8M8 11.2v.1",
  terminal: "M2.5 3.5h11v9h-11zM5 6.5l2 1.6-2 1.6M8.5 10h2.5",
  mic: "M6 3.5a2 2 0 014 0v4a2 2 0 01-4 0zM3.8 7.5a4.2 4.2 0 008.4 0M8 11.7v2M5.8 13.7h4.4",
  headphones: "M2.8 11V8.5a5.2 5.2 0 0110.4 0V11M2.8 9.5h2v4h-2zM11.2 9.5h2v4h-2z",
  sync: "M3 8a5 5 0 018.7-3.4M13 8a5 5 0 01-8.7 3.4M11.9 2.3v2.5H9.4M4.1 13.7v-2.5h2.5",
  chevronDown: "M4 6l4 4 4-4",
  chevronUp: "M4 10l4-4 4 4",
  target: "M8 2.5a5.5 5.5 0 100 11 5.5 5.5 0 100-11M8 5.5a2.5 2.5 0 100 5 2.5 2.5 0 100-5",
  chat: "M2.5 3.5h11v7H7l-3 2.5v-2.5H2.5z",
  rotate: "M12.5 6.5A5 5 0 1 0 13 9.5M12.5 2.5v4h-4",
  link: "M6.5 9.5l3-3M7 4.5l1-1a2.5 2.5 0 013.5 3.5l-1 1M9 11.5l-1 1a2.5 2.5 0 01-3.5-3.5l1-1",
  user: "M8 2.5a2.8 2.8 0 100 5.6 2.8 2.8 0 100-5.6M3 13.5c.6-2.6 2.6-4 5-4s4.4 1.4 5 4",
  prev: "M4 3.5v9M12 3.5L6 8l6 4.5z",
  next: "M12 3.5v9M4 3.5L10 8l-6 4.5z",
  hold: "M8 2.5a5.5 5.5 0 100 11 5.5 5.5 0 100-11M8 5v3l2 1.5",
  chevronRight: "M6 3.5L10.5 8 6 12.5",
  check: "M3.5 8.5l3 3 6-7",
  search: "M7 2.5a4.5 4.5 0 100 9 4.5 4.5 0 100-9M10.3 10.3l3.2 3.2",
  warning: "M8 2.5L14 13H2zM8 6.5v3M8 11.2v.1",
  plus: "M8 3v10M3 8h10",
  minus: "M3 8h10",
  fit: "M2.5 6V2.5H6M10 2.5h3.5V6M13.5 10v3.5H10M6 13.5H2.5V10",
  close: "M4 4l8 8M12 4l-8 8",
  panel: "M2.5 3h11v10h-11zM9.5 3v10",
  fullscreen: "M9.5 2.5h4v4M13.5 2.5L9.5 6.5M6.5 13.5h-4v-4M2.5 13.5L6.5 9.5",
  zoomIn: "M7 2.5a4.5 4.5 0 100 9 4.5 4.5 0 100-9M10.3 10.3L13.5 13.5M5 7h4M7 5v4",
  zoomOut: "M7 2.5a4.5 4.5 0 100 9 4.5 4.5 0 100-9M10.3 10.3L13.5 13.5M5 7h4",
  filter: "M2.5 3.5h11l-4.2 5v4l-2.6 1.2V8.5z",
  external: "M9 2.5h4.5V7M13.5 2.5L7.5 8.5M11 9.5v4H2.5V5h4",
  tag: "M2.5 2.5h5.3l5.7 5.7-5.6 5.6-5.4-5.7zM5.4 5.4h.01",
  chevronLeft: "M10 3.5L5.5 8 10 12.5",
  play: "M5 3.5v9l7-4.5z",
  pause: "M5.5 3.5v9M10.5 3.5v9",
  volume: "M2.5 6h2.5l3.5-3v10l-3.5-3H2.5zM11 5.8a3.2 3.2 0 010 4.4M12.9 3.8a6 6 0 010 8.4",
  muted: "M2.5 6h2.5l3.5-3v10l-3.5-3H2.5zM11 6.2l3.4 3.6M14.4 6.2L11 9.8",
  loop: "M3 7.5v-1a2 2 0 012-2h7.5M10.5 2.5l2 2-2 2M13 8.5v1a2 2 0 01-2 2H3.5M5.5 13.5l-2-2 2-2",
  frameBack: "M11 4L6 8l5 4M4.5 4v8",
  frameNext: "M5 4l5 4-5 4M11.5 4v8",
  image: "M2.5 3.5h11v9h-11zM2.5 10.5l3-3 3 3 2-2 3 3M10.5 6h.01",
  copy: "M5.5 5.5h7v7h-7zM3.5 10.5v-7h7",
  steam: "M8 1.5a6.5 6.5 0 106.5 6.5M11 5.5a1.5 1.5 0 100 .01M5 10.5l3-1.5 3-3",
  lock: "M4 7.5h8v6H4zM5.5 7.5V5a2.5 2.5 0 015 0v2.5",
  shield: "M8 1.8l5 2v4c0 3-2.2 5.2-5 6.4-2.8-1.2-5-3.4-5-6.4v-4z",
  map: "M2.5 4.2l3.7-1.4 3.6 1.4 3.7-1.4v9l-3.7 1.4-3.6-1.4-3.7 1.4zM6.2 2.8v9M9.8 4.2v9",
  dots: "M8 3.6v.1M8 8v.1M8 12.4v.1",
  eye: "M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8zM8 6.2a1.8 1.8 0 100 3.6 1.8 1.8 0 100-3.6",
  eyeOff: "M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8zM2.5 2.5l11 11",
  select: "M3.5 2.5l9 5-4 1-1.8 4.5z",
  arrow: "M3 13L13 3M7.5 3H13v5.5",
  pen: "M2.5 12c2-.5 2.5-5 5-5s1.5 4.5 3.5 4.5 2-2 2.5-3",
  text: "M3.5 3.5h9M8 3.5v9M6 12.5h4",
  eraser: "M6 13.5h7.5M2.8 9.8L8.6 4l4 4-5.5 5.5H5.5z",
  undo: "M5.5 3.5l-3 3 3 3M2.5 6.5h7a3.5 3.5 0 010 7H7",
  redo: "M10.5 3.5l3 3-3 3M13.5 6.5h-7a3.5 3.5 0 000 7H9",
  download: "M8 2.5v8M4.5 7L8 10.5 11.5 7M3 13.5h10",
  upload: "M8 10.5v-8M4.5 6L8 2.5 11.5 6M3 13.5h10",
  present: "M2.5 3h11v7.5h-11zM8 10.5v3M5.5 13.5h5",
  trash: "M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.7 9h5.6l.7-9",
  route: "M3.5 12.5a1 1 0 100 .01M12.5 3.5a1 1 0 100 .01M4.5 12c3-1 1-4.5 4-5.5s3-1.5 3.3-2.6",
  clock: "M8 2a6 6 0 100 12A6 6 0 108 2M8 4.8V8l2.2 1.4",
  swap: "M5 13V3m0 0L2.5 5.5M5 3l2.5 2.5M11 3v10m0 0l-2.5-2.5M11 13l2.5-2.5",
  edit: "M10.5 2.5l3 3-8 8H2.5v-3zM9 4l3 3",
} as const;

export function Icon({ name, size = 16, label }: { name: keyof typeof paths; size?: number; label?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <path d={paths[name]} />
    </svg>
  );
}
